/* @flow */

import omit from 'lodash.omit';
import { API_URL, API_CLIENT_ID, API_CLIENT_SECRET } from '../../Constants';

export function registerUser(phoneNumber: string, queryString: string, silent: boolean = false) {
  return {
    url: `${API_URL}/registrations`,
    force: true,
    body: {
      client_id: API_CLIENT_ID,
      phone_number: phoneNumber,
      query_string: queryString,
      silence: silent,
    },
  };
}

export function fetchUser(userId: string) {
  return {
    url: `${API_URL}/users/${userId}`,
    transform: (response: Object) => ({ users: response }),
    update: {
      users: (prevUsers: Object, user: Object) => ({
        ...prevUsers,
        [user.id]: user,
      }),
    },
  };
}

export function authenticateUser(phoneNumber: string, otpCode: string) {
  return {
    url: `${API_URL}/oauth/token`,
    force: true,
    body: {
      grant_type: 'password',
      client_id: API_CLIENT_ID,
      client_secret: API_CLIENT_SECRET,
      scope: 'identity read write',
      username: phoneNumber,
      password: otpCode,
    },
    transform: (response: Object) => ({ authentication: response, users: response.user }),
    update: {
      users: (prevUsers: Object, user: Object) => ({
        ...prevUsers,
        [user.id]: user,
      }),
    },
  };
}

export function unauthenticateUser(userId: string, authToken: string) {
  return {
    url: `${API_URL}/oauth/revoke`,
    force: true,
    body: {
      token: authToken,
    },
    transform: () => ({ authentication: {}, users: {}, paymentSources: {} }),
    update: {
      users: (prevUsers: Object) => omit(prevUsers, userId),
      paymentSources: () => {},
    },
  };
}

export function updateUser(userId: string, updates: { email: ?string }) {
  let { email } = updates;

  let body = {};
  if (email) body.email = email;

  return {
    url: `${API_URL}/users/${userId}`,
    options: {
      method: 'PATCH',
    },
    force: true,
    body,
    transform: (response: Object) => ({ users: response }),
    update: {
      users: (prevUsers: Object, user: Object) => ({
        ...prevUsers,
        [`${user.id}`]: user,
      }),
    },
  };
}

export function updateUserProfile(
  userId: string,
  updates: { firstName: ?string, lastName: ?string }
) {
  let { firstName, lastName } = updates;

  let body = {};
  if (firstName) body.first_name = firstName;
  if (lastName) body.last_name = lastName;

  return {
    url: `${API_URL}/users/${userId}/profile`,
    options: {
      method: 'PATCH',
    },
    force: true,
    body,
    transform: (response: Object) => ({ users: response }),
    update: {
      users: (prevUsers: Object, userProfile: Object) => ({
        ...prevUsers,
        [`${userProfile.user_id}`]: {
          ...prevUsers[userProfile.user_id],
          profile: userProfile,
        },
      }),
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/users/queries.js